import { Component, OnInit, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfPaginatedListOfRoleListItemDto,
  CustomResultOfRoleControllerClaimsDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RoleControllerClaimsDto } from '../../../core/api/models/role-controller-claims-dto';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { MenuClaimDto } from './../../../core/api/models/menu-claim-dto';
import { PaginatedListOfRoleListItemDto } from './../../../core/api/models/paginated-list-of-role-list-item-dto';
import { RoleListItemDto } from './../../../core/api/models/role-list-item-dto';
import { RoleOrganizationDto } from './../../../core/api/models/role-organization-dto';
import { ClaimsService } from './../../../core/api/services/claims.service';
import { RolesService } from './../../../core/api/services/roles.service';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { CustomClaimDto } from './models/custom-claim-dto';
import { CustomMenuDto } from './models/custom-menu-dto';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { RolesFormComponent } from "./roles-form/roles-form.component";
import { RolesCloneFormComponent } from "./roles-clone-form/roles-clone-form.component";
import { RoleUsersFormComponent } from "./role-users-form/role-users-form.component";
import { RoleOrganizationsComponent } from "./role-organizations/role-organizations.component";


@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    imports: [BaseIndexModule, RolesFormComponent, RolesCloneFormComponent, RoleUsersFormComponent, RoleOrganizationsComponent]
})
export class RolesComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties

  pageName = PageNames.roles;
  componentSelector: string = 'app-roles';

  protected currentService = inject(RolesService);
  paginationApiMethodName: string = this.currentService.rolesGetRolesWithPagination.name;
  deleteApiMethodName: string = this.currentService.rolesDelete.name;
  auditApiMethodName: string = this.currentService.rolesGetRolesAudit.name;

  modelWithPagination$: Observable<PaginatedListOfRoleListItemDto>;
  items$: ReplaySubject<RoleListItemDto[]> = new ReplaySubject<
    RoleListItemDto[]
  >(1);

  formPageConfig: FormPageConfig<RoleControllerClaimsDto> = {};

  menusClaims: Array<CustomClaimDto>;

  isShowRolesClone: boolean = false;
  isVisibleUserRoleForm: boolean = false;
  userRoleId: number;
  userRoleOrganizationId: number;
  roleUsersSelected: string[];

  isShowClaimAuditPage: boolean = false;
  roleOrganizations: RoleOrganizationDto[] = [];
  roleNameElements: NodeListOf<Element>;

  roleIdSelected: number = 0;
  roleSelected: RoleListItemDto;
  //#endregion

  constructor(
    public claimsService: ClaimsService
  ) {
    super();
  }
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.isAddBtnWithLoading = true;
      this.pageConfig.isShowTable = false;

      this.items$.pipe(this.basePipeOperators()).subscribe((items) => {
        if (this.roleSelected) this.onSelect(this.roleSelected);
        else if (items) this.onSelect(items[0]);
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Clone_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.isShowRolesClone,
          selectedPropKey: [
            {
              keyName: this.componentProperties.roleIdSelected,
              keyType: typeof this.roleIdSelected,
            },
          ],
        });
    }
  }

  //#region select role

  onSelect(role: RoleListItemDto) {
    this.roleIdSelected = role.id;
    this.roleSelected = role;
    this.roleOrganizations = role.organizations;
  }

  getSelectedOrganization(organizationId: number) {
    this.showUserRoleForm(this.roleIdSelected, organizationId);
  }

  //#endregion

  //#region user role

  showUserRoleForm(roleId: number, organizationId: number) {
    this.userRoleOrganizationId = organizationId;
    this.userRoleId = roleId;
    this.getRoleUsersApi(roleId, organizationId);
  }

  //#endregion

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .rolesUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfRoleControllerClaimsDto) => {
        try {
          this.formPageConfig.editData = res.data;
          this.menusClaims = res.data?.menusClaims;
          this.menusClaims = this.mapMenusClaims(this.menusClaims);
          this.pageConfig.isVisibleForm = true;
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.systemManagement
          );
        }
      });
  }

  getClaimMenusForCreateApi() {
    this.currentService
      .rolesCreateGet()
      .pipe(this.basePipeOperators())
      .subscribe(
        (items) => {
          if (items) {
            try {
              this.menusClaims = items.data;
              this.menusClaims = this.mapMenusClaims(this.menusClaims);
              this.setParentQueryString();
              this.location.go(
                window.location.pathname + '?key-formType=create'
              );
              this.pageConfig.isVisibleForm = true;
            } catch (error) {
              this.loggerService.logError(
                this.tagName,
                error,
                EventTypes.systemManagement
              );
            }
          }
        },
        (error) => {
          this.pageConfig.isVisibleForm = undefined;
          const timeout = setTimeout(() => {
            this.pageConfig.isVisibleForm = false;
            clearTimeout(timeout);
          }, 10);
        }
      );
  }

  getRoleUsersApi(roleId, organizationId) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .rolesGetRoleUsers({ roleId, organizationId })
      .pipe(
        this.basePipeOperators(),
        finalize(() => {
          this.pageConfig.loading = false;
        })
      )
      .subscribe((users) => {
        this.roleUsersSelected = users?.data;
        this.isVisibleUserRoleForm = true;
      });
  }

  //#endregion

  onCreate() {
    this.getClaimMenusForCreateApi();
  }

  mapMenusClaims(menusClaims: MenuClaimDto[]): MenuClaimDto[] {
    try {
      const visibleMenuClaims = (menus: CustomMenuDto[]) =>
        menus.forEach((menu) => {
          menu.isVisible = true;

          if (menu.claims?.length)
            menu.claims.map((claim) => (claim.isVisible = true));

          if (menu.subMenus?.length) visibleMenuClaims(menu.subMenus);
        });

      visibleMenuClaims(menusClaims);
      return menusClaims;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getFormResponse(isSuccess) {
    try {
      super.getFormResponse(isSuccess);

      if (isSuccess) {
        this.items$.pipe(this.basePipeOperators()).subscribe((items) => {
          if (this.roleSelected) {
            this.roleSelected = items.find(
              (role) => role.id == this.roleSelected.id
            );
            if (this.roleIdSelected) this.onSelect(this.roleSelected);
          } else this.onSelect(items[0]);
        });
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onClone(roleId: number, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Clone_key +
          '=' +
          roleId
      );
    }
    this.isShowRolesClone = true;
    this.roleIdSelected = roleId;
  }

  getRolesCloneFormResponse(event) {
    this.location.go(window.location.pathname);
    this.showParent = true;
    this.getParentQueryString();
    if (event) this.getTableData();

    this.isShowRolesClone = false;
  }
}
